import { Injectable } from '@angular/core';
import { ApiService } from 'app/main/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class CurriculumService {

  constructor(
    private api: ApiService
  ) {

  }

  async getCurriculumById(curriculumId) {
    return this.api.getRequestPromise(`curriculum/${curriculumId}`);
  }

  async postCurriculum(obj) {
    return this.api.postRequestPromise(`curriculum`, obj);
  }

  async putCurriculum(obj) {
    return this.api.putRequestPromise(`curriculum`, obj);
  }
}


